import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../../pessoa/cliente/services';
import { TypeaheadClienteComponent } from '../../../pessoa/cliente/typeahead';
import { ClienteCarteiraBaixar } from '../cliente-carteira-baixar';
import { ClienteCarteiraBaixado } from '../cliente-carteira-baixado';
import { ClienteCarteiraBaixarHttpService } from '../services';
import { RepresentanteCrudHttpService } from '../../../pessoa/representante';

@Component({
    selector: 'sgt-cliente-carteira-baixar-modal',
    templateUrl: './cliente-carteira-baixar-modal.component.html',
    styleUrls: ['./cliente-carteira-baixar-modal.component.less']
})
export class ClienteCarteiraBaixarModalComponent implements OnInit {
    entityBaixa: ClienteCarteiraBaixar;

    editMode: boolean;
    canEditCliente: boolean;
    elModal: any;

    @Input() isRepresentante: boolean;
    @Input() titleInsert = 'Baixar cliente';
    @Input() subTitleInsert = 'Selecione o cliente e informe o motivo da baixa deste cliente';
    @Input() titleEdit = 'Editar baixa do cliente';
    @Input() subTitleEdit = 'Informe o motivo da baixa deste cliente';
    @Input() clienteInputLabel = 'Cliente';
    @Input() btnBaixarText = 'Baixar Cliente';
    @Output() afterCancel = new EventEmitter<any>();
    @Output() afterInsertBaixa = new EventEmitter<ClienteCarteiraBaixado>();
    @Output() afterEditBaixa = new EventEmitter<ClienteCarteiraBaixado>();

    @ViewChild('form') form: NgForm;
    @ViewChild('typeaeadCliente') typeaeadCliente: TypeaheadClienteComponent;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private clienteCarteiraBaixarHttpService: ClienteCarteiraBaixarHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                if (this.canEditCliente) {
                    this.typeaeadCliente?.setFocus();
                } else {
                    jQuery('#motivoBaixaCliente').trigger('focus');
                }

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Inserie uma nova baixa */
    insert(idCliente: number, motivoBaixa: string = null) {
        this.editMode = false;
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        this.entityBaixa = new ClienteCarteiraBaixar();
        this.entityBaixa.motivoBaixa = motivoBaixa;
        // Se informado o cliente para ser baixado então carregamos o cliente e não permitimos editar
        if (idCliente) {
            this.canEditCliente = false;
            this.loadCliente(idCliente);
        } else { // Se não, permite editar o cliente para poder selecioná-lo
            this.canEditCliente = true;
        }
    }

    /** Edita a baixa do cliente informado */
    edit(idCliente: number) {
        this.editMode = true;
        this.canEditCliente = false;
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        // Carregando os dados do cliente baixado
        this.clienteCarteiraBaixarHttpService.loadBaixa(idCliente)
            .subscribe(
                clienteBaixado => {
                    this.entityBaixa = new ClienteCarteiraBaixar();
                    this.loadCliente(clienteBaixado.idCliente);
                    this.entityBaixa.dataBaixa = clienteBaixado.dataBaixa;
                    this.entityBaixa.baixaManual = clienteBaixado.baixaManual;
                    this.entityBaixa.nomeUsuarioBaixa = clienteBaixado.nomeUsuarioBaixa;
                    this.entityBaixa.motivoBaixa = clienteBaixado.motivoBaixa;
                },
                ((error: ApiError) => {
                    this.messageService.error(error.message, 'Ocorreu um erro ao carregar o cliente baixado', error);
                    this.close();
                })
            );
    }

    /** Reseta o form e fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.entityBaixa = null;
    }

    /** Cancela a baixa do cliente */
    cancel() {
        this.close();
        this.afterCancel.emit();
    }

    /** Ao selecionar o cliente */
    onSelectCliente(cliente: Cliente) {
        if (cliente) {
            this.entityBaixa.idCliente = cliente.id;
            this.findRepresentanteCliente(cliente.idRepresentante);
        } else {
            this.onClearCliente();
        }
    }

    /** Ao remover o cliente */
    onClearCliente() {
        this.entityBaixa.idCliente = null;
        this.entityBaixa.representante = null;
    }

    /** Carrega o cliente da baixa */
    private loadCliente(idCliente: number) {
        this.clienteCrudHttpService.load(idCliente)
            .subscribe(
                cliente => {
                    this.entityBaixa.cliente = cliente;
                    this.onSelectCliente(this.entityBaixa.cliente);
                },
                (() => {
                    this.entityBaixa.idCliente = null;
                    this.entityBaixa.cliente = null;
                })
            );
    }

    /** Pesquisa o representante do cliente da baixa */
    private findRepresentanteCliente(idRepresentante: number) {
        this.representanteCrudHttpService.find(idRepresentante)
            .subscribe(
                representante => this.entityBaixa.representante = representante,
                () => this.entityBaixa.representante = null
            );
    }

    /** Realiza a baixa do cliente */
    baixar() {
        if (this.form.valid) {
            const btn = new ButtonLoader('#btnClienteBaixarModal');
            btn.loading('Baixando');

            this.clienteCarteiraBaixarHttpService.baixar(this.entityBaixa)
                .subscribe(
                    clienteBaixado => {
                        btn.reset();
                        this.messageService.success('', 'Cliente baixado com sucesso');

                        if (!this.editMode) {
                            this.afterInsertBaixa.emit(clienteBaixado);
                        } else {
                            this.afterEditBaixa.emit(clienteBaixado);
                        }

                        this.close();
                    },
                    (error: ApiError) => {
                        btn.reset();
                        this.messageService.error(error.message, 'Erro ao baixar o cliente', error);
                    }
                )
        } else {
            this.messageService.info('Para baixar é necessário informar corretamente todos os campos destacados em vermelho', 'Informação');
        }
    }
}
